<script>
    import QuestionLibrary from '../../Models/QuestionLibraryModel';
    import Loader from '../Loader.svelte';
    import {forms} from '../../lib/forms';
    import Field from '../../Forms/Field.svelte';


    export let cancelAction = () => {};
    export let saveAction = () => {};
    export let deleteAction = () => {};

    let control_type = "Library";

    let libraries = QuestionLibrary.getList();
    let selected_library_id;
    let selected_library;

    let selected_categories = [];

    let library_loading = false;

    let data = {};

    async function loadLibrary(library_id) {
        if (control_type == "Custom" || !library_id) return;

        selected_categories = [];
        library_loading = true;
        selected_library = await QuestionLibrary.getStatic(library_id);
        library_loading = false;
    }

    function handleSave() {
        if (control_type == "Library") {
           saveAction({
               control_type,
               selected_library,
               selected_categories
            });
        } else {
            saveAction({
                control_type,
                data
            })
        }
    }

    $: loadLibrary(selected_library_id);
</script>


<div class="modal is-active">
    <div class="modal-background" on:click={cancelAction}></div>
    <div class="modal-card is-fullwidth">
        <Loader loading={!$libraries} fullscreen={false}>
            <header class="modal-card-head">
                <p class="modal-card-title">Add Category</p>
                <span class="delete" aria-label="close" on:click|preventDefault={cancelAction}></span>
            </header>
            <form on:submit={handleSave}>
                <section class="modal-card-body">
                    <div class="field is-horizontal">
                        <div class="field-label is-normal">
                            <span class="label">Category Type</span>
                        </div>
                        <div class="field-body">
                            <div class="field">
                                <div class="control select is-fullwidth">
                                    <select bind:value={control_type}>
                                        <option>Library</option>
                                        <option>Custom</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                    {#if control_type == "Library"}
                        <div class="field is-horizontal">
                            <div class="field-label is-normal">
                                <span class="label">Question Library</span>
                            </div>
                            <div class="field-body">
                                <div class="field">
                                    <div class="control select is-fullwidth">
                                        <select bind:value={selected_library_id}>
                                            {#each $libraries as lib}
                                                <option value={lib._id}>{lib.name}</option>
                                            {/each}
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {#if selected_library}
                            <Loader loading={library_loading} fullscreen={false}>
                                <table class="table is-striped is-fullwidth">
                                    <thead>
                                        <tr>
                                            <th width="100px">&nbsp;</th>
                                            <th>Category</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {#each [...selected_library.categories] as category (category.id)}
                                            <tr>
                                                <td><input id="chk_{category.id}" type="checkbox" bind:group={selected_categories} value={category.id} /></td>
                                                <th><label for="chk_{category.id}">{category.details.name}</label></th>
                                            </tr>
                                        {/each}
                                    </tbody>
                                </table>
                            </Loader>
                        {/if}
                    {:else}
                        {#each forms['category'] as field}
                            {#if !(field.type == "hidden") && !(field.preq && data[field.preq.field] != field.preq.value)}
                                <Field {...field} bind:value={data[field.name]} />
                            {/if}
                        {/each}
                    {/if}
                </section>
                <footer class="modal-card-foot">
                    <span class="button" on:click|preventDefault={cancelAction}>Cancel</span>
                    <button class="button is-success">Save</button>
                </footer>
            </form>
        </Loader>
    </div>
</div>

<style>
    .modal {
        z-index: 999;
    }

    .modal-card-foot {
        justify-content: flex-end;
    }

    .modal-card-body {
        max-height: calc(100vh - 175px);
    }
</style>